import Calendar from "./Calendar";
import calendarEventsTemplatesContainer from "../../../../containers/calendar-events-templates";

export default calendarEventsTemplatesContainer(Calendar);
